import * as TemplateActionTypes from '../../../constants/contents/TemplateActionTypes';

const initialState = {
    searchKeyword: '',
    searchType: 'title',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case TemplateActionTypes.CLEAR_ITEMS:
            return {
                searchKeyword: '',
                searchType: 'title',
            };
        case TemplateActionTypes.SEARCH_KEYWORD:
            return Object.assign({}, state, {
                searchKeyword: action.searchKeyword,
                searchType: action.searchType,
            });
        default :
            return state;
    }
}
